import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import App from './App';
import * as rendererOnlyIndex from './rendererOnlyIndex';

document.addEventListener("DOMContentLoaded", () => {

  const cardlistRoot = document.querySelector('.wp-block-osica-card-list');
  if (!cardlistRoot) {
    //Ignore page if not found card list.
    return;
  }

  cardlistRoot.addEventListener("dragstart", event => {
    if (event instanceof DragEvent
      && event.target && event.target instanceof HTMLElement
      && event.dataTransfer) {

      event.target.classList.add("dragging");
      console.log("drag start");
      console.log(event.target.closest("[draggable=true]"));

      const parentElement = event.target.closest("[draggable=true]");
      if (parentElement) {
        event.dataTransfer.setData("application/json", JSON.stringify({
          cardProductId: Number.parseInt(parentElement.getAttribute('data-product-id') ?? ''),
          cardNo: parentElement.getAttribute('data-card-no') ?? '',
          cardName: parentElement.getAttribute('data-card-name') ?? '',
          canFavorite: parentElement.getAttribute('data-can-favorite') === '1' ?? false
        }));

        window.dispatchEvent(new Event('carddragstart'));
      }
    }
  });


  document.addEventListener("dragend", event => {
    if (event instanceof DragEvent && event.target && event.target instanceof HTMLElement) {
      event.target.classList.remove("dragging");
      window.dispatchEvent(new Event('carddragend'));
    }
  });

  const button = document.getElementById('debug-custom-event');
  if (button) {
    button.onclick = (event) => {
      event.preventDefault();
      window.dispatchEvent(
        new CustomEvent("insertcard", { detail: { cardProductId: 1, cardNo: '01-001', cardName: '各務原 なでしこ' } })
      );
    };
  }

  let deckBuilderRoot = document.getElementById('osica-deck-builder');
  if (!deckBuilderRoot) {
    const wordPressRoot = document.querySelector('.wp-site-blocks');
    deckBuilderRoot = document.createElement('div');
    deckBuilderRoot.id = 'osica-deck-builder';
    if (wordPressRoot) {
      wordPressRoot.appendChild(deckBuilderRoot);
    } else {
      document.appendChild(deckBuilderRoot);
    }
  }

  Modal.setAppElement('#osica-deck-builder');
  const root = ReactDOM.createRoot(
    document.getElementById('osica-deck-builder') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

});


document.addEventListener("DOMContentLoaded", () => {
  rendererOnlyIndex.init();
});